import { defaultTenantCountryCode, isValidCountryCode, normalizeCountryCodeInput } from '@/lib/country-codes'

const CITY_MAX_LENGTH = 128

export function cityRequiresWorkMode(workMode: string): boolean {
  const mode = workMode.trim()
  return mode === 'onsite' || mode === 'hybrid'
}

export function normalizeCityInput(raw: string): string {
  return raw.trim().slice(0, CITY_MAX_LENGTH)
}

export { normalizeCountryCodeInput }

/** Map API row to editable city (structured city, else legacy free-text location). */
export function opportunityCityForEdit(city: string | null | undefined, location: string | null | undefined): string {
  const structured = (city || '').trim()
  if (structured) return structured
  const legacy = (location || '').trim()
  if (!legacy || legacy.toLowerCase() === 'remote') return ''
  return legacy
}

/** Map API row to editable country (stored code, else tenant default). */
export function opportunityCountryForEdit(
  countryCode: string | null | undefined,
  locale = 'en-AU',
): string {
  const stored = normalizeCountryCodeInput(countryCode || '')
  if (stored && isValidCountryCode(stored, locale)) return stored
  return defaultTenantCountryCode(locale)
}

export function validateOpportunityLocationFields(args: {
  work_mode: string
  city: string
  country_code: string
}): { ok: true } | { ok: false; message: string } {
  const workMode = args.work_mode.trim()
  const country = normalizeCountryCodeInput(args.country_code)

  if (!country) {
    return { ok: false, message: 'Select a country.' }
  }
  if (!isValidCountryCode(country)) {
    return { ok: false, message: 'Select a valid country from the list.' }
  }

  if (cityRequiresWorkMode(workMode)) {
    const city = normalizeCityInput(args.city)
    if (!city) {
      return { ok: false, message: 'Enter a city for on-site or hybrid roles.' }
    }
  }

  return { ok: true }
}

export function structuredLocationPayload(args: {
  work_mode: string
  city: string
  country_code: string
}): { work_mode: string; city: string; country_code: string } {
  const workMode = args.work_mode.trim()
  const country = normalizeCountryCodeInput(args.country_code)
  const city = cityRequiresWorkMode(workMode) ? normalizeCityInput(args.city) : ''
  return { work_mode: workMode, city, country_code: country }
}
